// pipes
import { titleCasePipe } from "shared/pipes";

// components
import { MissingRow } from "./missing-row";

const ItemsTable = ({ data }) => {
    const columns = ['barcode', 'user', 'email', 'box_from', "missing_from", 'action'];
    if (data.length === 0) {
        return (
            <>
                <div className="icon-text">
                    <span className="icon is-strong has-text-danger">
                        <i className="fas fa-ban"></i>
                    </span>
                    <span className="title is-4">No Results</span>
                </div>

                <p className="block">
                    There is no results for this query.
                </p>
            </>
        )
    };

    return (
        <table className="table is-striped is-fullwidth">
            <thead>
                <tr>
                    {columns.map((column) => (
                        <th key={column}>{titleCasePipe.transform(column)}</th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map((missingItem, index) => (
                    <MissingRow item={missingItem} key={`row-${index}`} count={index + 1} />
                ))}
            </tbody>
        </table>
    )
};

export { ItemsTable };
